import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M20 4H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h2v2c0 .6.4 1 1 1 .2 0 .4-.1.6-.2l3.7-2.8H20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm1 12c0 .6-.4 1-1 1h-9l-.3.2L7 20v-3H4c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1h16c.6 0 1 .4 1 1v10z',
    'M12 7h-1v3H8v1h3v3h1v-3h3v-1h-3z',
  ],
  height: 24,
  width: 24,
});
